import type { MediaBuyingModerationStatus, MediaBuyingModerationStatusSections, MediaBuyingPayoutStatus, MediaBuyingPostsStatus } from "@/types/status";
import type {
  GetMediaBuyingReportsUnreportedFundsData,
  GetMediaBuyingReportsUnreportedFundsResponse,

  GetMediaBuyingReportsSummaryData,
  GetMediaBuyingReportsSummaryResponse,

  GetMediaBuyingPaymentsData,
  GetMediaBuyingPaymentsResponse,

  GetMediaBuyingPaymentsByIdData,
  GetMediaBuyingPaymentsByIdResponse,

  GetMediaBuyingPaymentsByIdCommentsData,
  GetMediaBuyingPaymentsByIdCommentsResponse,

  PostMediaBuyingPaymentsByIdCommentsData,
  PostMediaBuyingPaymentsByIdCommentsResponse,

  PostMediaBuyingPaymentsByIdMarkAsReadData,
  PostMediaBuyingPaymentsByIdMarkAsReadResponse,

  PostMediaBuyingPaymentsByIdMarkAsUnreadData,
  PostMediaBuyingPaymentsByIdMarkAsUnreadResponse,

  GetMediaBuyingPostsData,
  GetMediaBuyingPostsResponse,

  GetMediaBuyingPostsByIdData,
  GetMediaBuyingPostsByIdResponse,

  GetMediaBuyingPostsByIdCommentsData,
  GetMediaBuyingPostsByIdCommentsResponse,

  PostMediaBuyingPostsByIdCommentsData,
  PostMediaBuyingPostsByIdCommentsResponse,

  PostMediaBuyingPostsByIdMarkAsReadData,
  PostMediaBuyingPostsByIdMarkAsReadResponse,

  PostMediaBuyingPostsByIdMarkAsUnreadData,
  PostMediaBuyingPostsByIdMarkAsUnreadResponse,

  GetMediaBuyingPaymentMethodsData,
  GetMediaBuyingPaymentMethodsResponse,

  GetMediaBuyingPaymentMethodsBlacklistData,
  GetMediaBuyingPaymentMethodsBlacklistResponse,

  PostMediaBuyingPaymentMethodsBlacklistData,
  PostMediaBuyingPaymentMethodsBlacklistResponse,

  PutMediaBuyingPaymentMethodsBlacklistByIdData,
  PutMediaBuyingPaymentMethodsBlacklistByIdResponse,

  DeleteMediaBuyingPaymentMethodsBlacklistByIdData,
  DeleteMediaBuyingPaymentMethodsBlacklistByIdResponse,

  GetMediaBuyingCampaignsByIdUsedWalletsData,
  GetMediaBuyingCampaignsByIdUsedWalletsResponse,

  GetMediaBuyingUrlBlacklistsData,
  GetMediaBuyingUrlBlacklistsResponse,

  PostMediaBuyingUrlBlacklistsData,
  PostMediaBuyingUrlBlacklistsResponse,

  PutMediaBuyingUrlBlacklistsByIdData,
  PutMediaBuyingUrlBlacklistsByIdResponse,

  DeleteMediaBuyingUrlBlacklistsByIdData,
  DeleteMediaBuyingUrlBlacklistsByIdResponse,

  GetMediaBuyingCampaignsData,
  GetMediaBuyingCampaignsResponse,

  GetMediaBuyingPaymentsTransfersData,
  GetMediaBuyingPaymentsTransfersResponse,

  GetMediaBuyingCampaignsTransferableBalancesData,
  GetMediaBuyingCampaignsTransferableBalancesResponse,

  GetMediaBuyingCampaignsTransferableBalanceRecipientsData,
  GetMediaBuyingCampaignsTransferableBalanceRecipientsResponse,

  PostMediaBuyingPaymentsTransfersData,
  PostMediaBuyingPaymentsTransfersResponse
} from "@/types/openapi-ts";
import type { AxiosInstance } from "axios";

export function getMediaBuyingApiModule(affiliatesApi: AxiosInstance) {
  return {
    // reports
    getUnreportedFunds(params: GetMediaBuyingReportsUnreportedFundsData['query']) {
      return affiliatesApi.get<GetMediaBuyingReportsUnreportedFundsResponse>(
        '/media-buying/reports/unreported-funds',
        { params }
      );
    },
    getMediaBuyingReports(params: GetMediaBuyingReportsSummaryData['query']) {
      return affiliatesApi.get<GetMediaBuyingReportsSummaryResponse>('/media-buying/reports/summary', { params });
    },
    // Campaign
    // getCampaignInfo(id: string, params: any) {
    //   return affiliatesApi.get<any>(
    //     `/media-buying/campaigns/${id}`,
    //     { params }
    //   );
    // },
    // Channel
    // getChannelInfo(id, params) {
    //   return affiliatesApi.get(`/media-buying/channels/${id}`, { params });
    // },
    // Payments
    getMediaBuyingPayments(params: GetMediaBuyingPaymentsData['query']) {
      return affiliatesApi.get<GetMediaBuyingPaymentsResponse>('/media-buying/payments', { params });
    },
    getMediaBuyingPaymentsInfo(id: string, params: GetMediaBuyingPaymentsByIdData['query']) {
      return affiliatesApi.get<GetMediaBuyingPaymentsByIdResponse>(`/media-buying/payments/${id}`, { params });
    },
    getMediaBuyingPaymentComments(id: string) {
      return affiliatesApi.get<GetMediaBuyingPaymentsByIdCommentsResponse>(
        `/media-buying/payments/${id}/comments?sort_dir=asc`
      );
    },
    postMediaBuyingPaymentComments(id: string, data: PostMediaBuyingPaymentsByIdCommentsData['body']) {
      return affiliatesApi.post<PostMediaBuyingPaymentsByIdCommentsResponse>(
        `/media-buying/payments/${id}/comments`,
        data
      );
    },
    postMediaBuyingPaymentChangeStatus(
      id: string,
      section: MediaBuyingModerationStatusSections,
      status:  MediaBuyingModerationStatus |  MediaBuyingPayoutStatus
    ) {
      // ts-expect-error включает в себя множество запросов
      return affiliatesApi.post<void>(`/media-buying/payments/${id}/${section}/${status}`);
    },
    postMediaBuyingPaymentMarkAsRead(id: string) {
      return affiliatesApi.post<PostMediaBuyingPaymentsByIdMarkAsReadResponse>(
        `/media-buying/payments/${id}/mark-as-read`
      );
    },
    postMediaBuyingPaymentMarkAsUnread(id: string) {
      return affiliatesApi.post<PostMediaBuyingPaymentsByIdMarkAsUnreadResponse>(
        `/media-buying/payments/${id}/mark-as-unread`
      );
    },
    // Posts
    getMediaBuyingPosts(params: GetMediaBuyingPostsData['query']) {
      return affiliatesApi.get<GetMediaBuyingPostsResponse>('/media-buying/posts', { params });
    },
    getMediaBuyingPostsInfo(id: string, params: GetMediaBuyingPostsByIdData['query']) {
      return affiliatesApi.get<GetMediaBuyingPostsByIdResponse>(`/media-buying/posts/${id}`, { params });
    },
    getMediaBuyingPostsComments(id: string) {
      return affiliatesApi.get<GetMediaBuyingPostsByIdCommentsResponse>(
        `/media-buying/posts/${id}/comments?sort_dir=asc`
      );
    },
    postMediaBuyingPostsComments(id: string, data: PostMediaBuyingPostsByIdCommentsData['body']) {
      return affiliatesApi.post<PostMediaBuyingPostsByIdCommentsResponse>(`/media-buying/posts/${id}/comments`, data);
    },
    postMediaBuyingPostsChangeStatus(id: string, status: MediaBuyingPostsStatus) {
      return affiliatesApi.post<void>(`/media-buying/posts/${id}/${status}`);
    },
    postMediaBuyingPostsMarkAsRead(id: string) {
      return affiliatesApi.post<PostMediaBuyingPostsByIdMarkAsReadResponse>(
        `/media-buying/posts/${id}/mark-as-read`
      );
    },
    postMediaBuyingPostsMarkAsUnread(id: string) {
      return affiliatesApi.post<PostMediaBuyingPostsByIdMarkAsUnreadResponse>(
        `/media-buying/posts/${id}/mark-as-unread`
      );
    },
    getMediaBuyingPaymentMethods() {
      return affiliatesApi.get<GetMediaBuyingPaymentMethodsResponse>('/media-buying/payment-methods');
    },
    getMediaBuyingBlacklist(params: GetMediaBuyingPaymentMethodsBlacklistData['query']) {
      return affiliatesApi.get<GetMediaBuyingPaymentMethodsBlacklistResponse>(
        '/media-buying/payment-methods/blacklist',
        { params }
      );
    },
    // getBlacklistById(id) {
    //   return affiliatesApi.get(`/media-buying/payment-methods/${id}/blacklist`);
    // },
    postMediaBuyingBlacklist(data: PostMediaBuyingPaymentMethodsBlacklistData['body']) {
      return affiliatesApi.post<PostMediaBuyingPaymentMethodsBlacklistResponse>(
        '/media-buying/payment-methods/blacklist',
        data
      );
    },
    putMediaBuyingBlacklist(id: string, data: PutMediaBuyingPaymentMethodsBlacklistByIdData['body']) {
      return affiliatesApi.put<PutMediaBuyingPaymentMethodsBlacklistByIdResponse>(
        `/media-buying/payment-methods/blacklist/${id}`,
        data
      );
    },
    deleteMediaBuyingBlacklist(id: string) {
      return affiliatesApi.delete<DeleteMediaBuyingPaymentMethodsBlacklistByIdResponse>(
        `/media-buying/payment-methods/blacklist/${id}`
      );
    },
    getMediaBuyingUsedWalletsById(id: string) {
      return affiliatesApi.get<GetMediaBuyingCampaignsByIdUsedWalletsResponse>(
        `/media-buying/campaigns/${id}/used-wallets`
      );
    },
    getMediaBuyingBlacklistUrls(params: GetMediaBuyingUrlBlacklistsData['query']) {
      return affiliatesApi.get<GetMediaBuyingUrlBlacklistsResponse>('/media-buying/url-blacklists', { params });
    },
    postMediaBuyingBlacklistUrls(data: PostMediaBuyingUrlBlacklistsData['body']) {
      return affiliatesApi.post<PostMediaBuyingUrlBlacklistsResponse>('/media-buying/url-blacklists', data);
    },
    putMediaBuyingBlacklistUrls(id: string, data: PutMediaBuyingUrlBlacklistsByIdData['body']) {
      return affiliatesApi.put<PutMediaBuyingUrlBlacklistsByIdResponse>(`/media-buying/url-blacklists/${id}`, data);
    },
    deleteMediaBuyingBlacklistUrls(id: string) {
      return affiliatesApi.delete<DeleteMediaBuyingUrlBlacklistsByIdResponse>(`/media-buying/url-blacklists/${id}`);
    },
    getMediaBuyingCampaigns(params: GetMediaBuyingCampaignsData['query']) {
      return affiliatesApi.get<GetMediaBuyingCampaignsResponse>('/media-buying/campaigns', { params });
    },
    getMediaBuyingPaymentsTransfers(params: GetMediaBuyingPaymentsTransfersData['query']) {
      return affiliatesApi.get<GetMediaBuyingPaymentsTransfersResponse>('/media-buying/payments/transfers', { params });
    },
    getMediaBuyingPaymentsTransferableBalances(params: GetMediaBuyingCampaignsTransferableBalancesData['query']) {
      return affiliatesApi.get<GetMediaBuyingCampaignsTransferableBalancesResponse>(
        '/media-buying/campaigns/transferable-balances',
        { params }
      );
    },
    getMediaBuyingPaymentsTransferableBalancesRecipients(
      params: GetMediaBuyingCampaignsTransferableBalanceRecipientsData['query']
    ) {
      return affiliatesApi.get<GetMediaBuyingCampaignsTransferableBalanceRecipientsResponse>(
        '/media-buying/campaigns/transferable-balance-recipients',
        { params }
      );
    },
    postMediaBuyingPaymentsTransfers(data: PostMediaBuyingPaymentsTransfersData['body']) {
      return affiliatesApi.post<PostMediaBuyingPaymentsTransfersResponse>('/media-buying/payments/transfers', data);
    },
  }
}
